function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2323(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.30832 6.77778C7.90381 6.77778 9.19721 5.48438 9.19721 3.88889C9.19721 2.2934 7.90381 1 6.30832 1C4.71283 1 3.41943 2.2934 3.41943 3.88889C3.41943 5.48438 4.71283 6.77778 6.30832 6.77778Z",
    stroke: "white",
    style: {
      stroke: "white",
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.19712 13.9999H3.41935C1.82386 13.9999 0.414995 12.5999 1.24673 11.2383C2.05998 9.90706 3.63398 8.94434 6.30823 8.94434C8.98247 8.94434 10.5565 9.90706 11.3697 11.2383C12.2015 12.5999 10.7926 13.9999 9.19712 13.9999Z",
    stroke: "white",
    style: {
      stroke: "white",
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2323);
export default __webpack_public_path__ + "static/media/Group 2323.eae04386d111f73b9e18c09092e8aea6.svg";
export { ForwardRef as ReactComponent };